export const model = {
    id: null,
    partner_doctor_id: "",
    partner_clinic_id: null,
    yes_doctor: "",
    doctor_id: "",
    created_at: '',
};
